import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { captureComponentLazyLoadError } from '../../service/ErrorsReporting/ErrorsReporting';
import { ScreenErrorMessage } from '../ScreenErrorMessage/ScreenErrorMessage';

import './ErrorPageBoundary.css';
import * as keyset from './ErrorPageBoundary.i18n';

const i18n = i18nFactory(keyset);

interface ErrorPageBoundryState {
    hasError: boolean;
}

interface ErrorPageBoundryProps {}

export class ErrorPageBoundary extends React.Component<
    ErrorPageBoundryProps,
    ErrorPageBoundryState
> {
    constructor(props: ErrorPageBoundryProps) {
        super(props);

        this.state = {
            hasError: false
        };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        captureComponentLazyLoadError(error, errorInfo);

        this.setState({ hasError: true });
    }

    render() {
        if (this.state.hasError) {
            return (
                <ScreenErrorMessage
                    cls={Bem.cls('error-page-boundary')}
                    header={i18n('error-text-header')}
                    text={i18n('error-text')}
                />
            );
        }

        return this.props.children;
    }
}
